// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".images-gallery[data-v-ded64860] :deep(.swiper-button-next:after){font-size:35px}.images-gallery[data-v-ded64860] :deep(.swiper-button-next){top:55%}.images-gallery[data-v-ded64860] :deep(.swiper-button-prev:after){font-size:35px}.images-gallery[data-v-ded64860] :deep(.swiper-button-prev){top:55%}.images-gallery[data-v-ded64860] :deep(.landscape-svg){height:1.25rem;width:1.25rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
